<template>
  <div id="sticky-show" class="buybox">
    <transition v-if="isMobile">
      <div class="buybox__mobile-heading container text-center">
        <div v-if="product.subtitle" class="product__subtitle text-lg text-primary-blue">{{ product.subtitle }}</div>
        <div v-else class="product__subtitle text-lg text-primary-blue">{{ selectedVariant.airtable_subtitle }}</div>
        <h1 v-if="product.title" class="product__title h5-sans">{{ product.title }}</h1>
        <h1 v-else-if="selectedVariant.airtable_title" class="product__title h5-sans">{{ selectedVariant.airtable_title }}</h1>
        <h1 v-else class="product__title h5-sans">{{ product.product_title }}</h1>
        <div v-if="yotpoProductId" class="product__reviews">
          <div class="yotpo bottomLine" data-appkey="SmtoQBJliJwFrBjSYjmEtOz31o6nMoLZfgcp3J4j" :data-product-id="yotpoProductId"></div>
        </div>
      </div>
    </transition>

    <BuyboxGallery 
      :product="product"
      :selectedVariant="selectedVariant"
      :isMobile="isMobile"
    />
    <div :id="product.id" class="buybox__content" :class="{ 'bundle-wrapper': isStayBundle, 'buybox__content-bundle-relative': (isStayBundle || isOneFlavor) && product.bundleRelatedToggleProduct  }" v-bind="{ 'data-bundle-wrapper': isStayBundle ? '' : null }">
      <transition v-if="!isMobile">
        <div>
          <div class="flex flex--align-center flex--space-between flex--wrap">
            <div v-if="product.subtitle" class="product__subtitle text-lg text-primary-blue">{{ product.subtitle }}</div>
            <div v-else class="product__subtitle text-lg text-primary-blue">{{ selectedVariant.airtable_subtitle }}</div>
            <div v-if="yotpoProductId" class="product__reviews">
              <div class="yotpo bottomLine" data-appkey="SmtoQBJliJwFrBjSYjmEtOz31o6nMoLZfgcp3J4j" :data-product-id="yotpoProductId"></div>
            </div>
          </div>
          <h1 v-if="product.title" class="product__title h5-sans">{{ product.title }}</h1>
          <h1 v-else-if="selectedVariant.airtable_title" class="product__title h5-sans">{{ selectedVariant.airtable_title }}</h1>
          <h1 v-else class="product__title h5-sans">{{ product.product_title }}</h1>
        </div>
      </transition>

      <div class="product__description text-dark-blue">
        <div v-if="product.description" v-html="product.description"></div>
        <div v-else v-html="selectedVariant.airtable_excerpt"></div>
      </div>
      <div v-if="isBundleSingleProduct" class="buybox__bundle-message text-center">Select {{ product.subBundleMin }}-{{ product.subBundleMax }} products to build your bundle and save {{ selectedSellingPlan.discount_value }}%:</div>
      
      <div v-if="(isStayBundle || isOneFlavor) && product.bundleRelatedToggleProduct" class="product__switch-container text-md text-primary-blue">
        <a :href="isStayBundle ? product.bundleRelatedToggleProduct : '#'"
          class="switch-option" 
          :class="{ 'active': !isStayBundle }"
          v-html="product.bundleRelatedToggleSwitchText[0].one_flavor ? product.bundleRelatedToggleSwitchText[0].one_flavor : 'Pick 1 Flavor'"
        ></a>
        <a :href="!isStayBundle ? product.bundleRelatedToggleProduct : '#'"
          class="switch-option"
          :class="{ 'active': isStayBundle }"
          v-html="product.bundleRelatedToggleSwitchText[0].bundle ? product.bundleRelatedToggleSwitchText[0].bundle : 'Bundle & Save 25%'"
        ></a>
      </div>

      <BuyboxBundle v-if="isBundleSingleProduct"
        :product="product"
        :selectedVariant="selectedVariant"
        :isSubscription="buyboxSubscription?.isSubscription"
        :isStayBundle="isStayBundle"
        :isOneFlavor="isOneFlavor"
        @update-option="onUpdateOption"
      />

      <BuyboxBundleGeneric v-if="isBundleGeneric"
        :product="product"
        :selectedVariant="selectedVariant"
        :isSubscription="buyboxSubscription?.isSubscription"
        :isStayBundle="isStayBundle"
        :isOneFlavor="isOneFlavor"
        @update-option="onUpdateOption"
      />

      <BuyboxOptions
        :product="product"
        :selectedVariant="selectedVariant"
        :isStayBundle="isStayBundle"
        :isOneFlavor="isOneFlavor"
        @update-option="onUpdateOption"
      />
      <BuyboxSubscription
        ref="buyboxSubscription"
        :product="product"
        :selectedVariant="selectedVariant"
        :isMultiPack="isMultiPack"
        :selectedSellingPlan="selectedSellingPlan"
        :isStayBundle="isStayBundle"
        :isOneFlavor="isOneFlavor"
        @update-option="onUpdateOption"
        @update-selling-plan="onUpdateSellingPlan"
        @update-is-subscription="onUpdateIsSubscription"
      />
      <div v-if="product.freebie" class="buybox__freebie">
        <svg class="buybox__freebie-icon">
          <use href="#freebie"></use>
        </svg>
        <span class="buybox__freebie-text" v-html="product.freebie.callout_text"></span>
      </div>
      <div v-if="shopLocation !== 'GB' && !product.customer && selectedVariant.available && !selectedVariant.sold_out" class="buybox__customer-login">
        <span @click="emit('toggle-uc-ship-modal')" class="buybox__link">Sign in</span> to add this product to your next shipment.
      </div>
      <div v-if="!selectedVariant.available || selectedVariant.sold_out" class="buybox__nwis text-sm">
        <span @click="emit('toggle-bis-modal')" class="buybox__link">{{ product.back_in_stock_modal.buy_box_link }}</span> {{ product.back_in_stock_modal.buy_box_message_after_link }}
      </div>
      <BuyboxATC
        :product="product"
        :isMultiPack="isMultiPack"
        :isSubscription="buyboxSubscription?.isSubscription"
        :selectedVariant="selectedVariant"
        :selectedSellingPlan="selectedSellingPlan"
        :isStayBundle="isStayBundle"
        :isOneFlavor="isOneFlavor"
        @track-event="trackEvent"
      />

      <div class="truemed-widget">
        <div shopify-tags="display-unless-ineligible" id="truemed-prequalify" icon-height="16" data-public-id="tm_qual_bjv51prpsl"></div>
      </div>
      <component
        src="https://truemed-public.s3.us-west-1.amazonaws.com/truemed-ads/prequal-widget.min.js"
        :is="'script'"
        defer
    ></component>

      <div v-if="product.announcements && product.announcements.items.length" class="buybox__announcements buybox__announcement-product">
        <div v-for="announcement in product.announcements.items" class="buybox__announcement flex flex--align-center">
          <svg class="buybox__announcement-icon">
            <use v-if="isStayBundle || isOneFlavor" href="#check-contained"></use>
            <use v-else href="#check-contained"></use>
          </svg>
          <span class="buybox__announcement-text">{{ announcement }}</span>
        </div>
        <div v-if="isStayBundle || isOneFlavor" class="buybox__announcement flex flex--align-center">
          <svg class="buybox__announcement-icon">
            <use href="#check-contained"></use>
          </svg>
          <div class="buybox__announcement-text tooltip">
            <span class="tooltip-title" v-html="product.announcements_default.sixty_day_guarantee_announcement"></span>
            <span class="tooltip-text text-xs" v-html="product.announcements_default.sixty_day_guarantee_tooltip_text"></span>
          </div>
        </div>
      </div>
      <div v-else class="buybox__announcements buybox__announcement-default">
        <div class="buybox__announcement flex flex--align-center">
          <svg class="buybox__announcement-icon">
            <use v-if="isStayBundle || isOneFlavor" href="#check-contained"></use>
            <use v-else href="#check-contained"></use>
          </svg>
          <span class="buybox__announcement-text" v-html="product.announcements_default.free_shipping"></span>
        </div>
        <div class="buybox__announcement flex flex--align-center">
          <svg class="buybox__announcement-icon">
            <use v-if="isStayBundle || isOneFlavor" href="#check-contained"></use>
            <use v-else href="#check-contained"></use>
          </svg>
          <span class="buybox__announcement-text" v-html="product.announcements_default.satisfaction_guarantee"></span>
        </div>
        <div v-if="isStayBundle || isOneFlavor" class="buybox__announcement flex flex--align-center">
          <svg class="buybox__announcement-icon">
            <use href="#check-contained"></use>
          </svg>
          <div class="buybox__announcement-text tooltip">
            <span class="tooltip-title" v-html="product.announcements_default.sixty_day_guarantee_announcement"></span>
            <span class="tooltip-text text-xs" v-html="product.announcements_default.sixty_day_guarantee_tooltip_text"></span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <BuyboxStickyBar v-if="false"
    :product="product"
    :selectedVariant="selectedVariant"
    :isMultiPack="isMultiPack"
    :yotpoProductId="yotpoProductId"
    :selectedSellingPlan="selectedSellingPlan"
    :isSubscription="buyboxSubscription?.isSubscription"
    :isStayBundle="isStayBundle"
    :isOneFlavor="isOneFlavor"
    @update-option="onUpdateOption"
    @update-selling-plan="onUpdateSellingPlan"
    @update-is-subscription="onUpdateIsSubscription"
    @track-event="trackEvent"
  />
  <div v-if="benefits.length || Object.keys(accordianData).length" class="container max-width product-information">
    <div class="pi__inner">
      <div class="pi__left-col">
        <div class="chip chip--transparent chip--medium-blue">Product information</div>
        <h2 v-if="product.product_information.title">{{ product.product_information.title }}</h2>

        <div v-if="benefits.length" class="pi__benefits-list">
          <div v-for="benefit in benefits" 
              :key="benefit.heading" 
              class="pi__benefit-item flex flex--align-center">
            <svg class="icon icon--xl">
              <use href="#check-contained"></use>
            </svg>
            <span class="pi__benefit-item__text">{{ benefit.heading }}</span>
          </div>
        </div>
        <BuyboxAccor
          :accordians="accordianData"
        />
      </div>

      <div v-if="product.product_information.pairs_well_with" class="pi__right-col">
        <div class="pi__pww-inner">
          <ImageField v-if="product.product_information.image" :key="product.product_information.image" class="pi__pww-image" :obj="{'url':product.product_information.image,'alt':'Image','width':1280,'height':1600}" width-param="width" sizes="(max-width: 640px) 100vw, 640px"/>

          <div class="pi__pww-product-wrapper">
            <div class="pi__pww-product flex"> 

              <ImageField v-if="product.product_information.pairs_well_with.featured_image" :key="product.product_information.pairs_well_with.featured_image" class="pi__pww-product-image" :obj="{'url':product.product_information.pairs_well_with.featured_image,'alt':'Image','width':256,'height':256}" width-param="width" sizes="128px"/>

              <div class="pi__pww-product-content flex flex--column">
                <div class="caption caps-sm">Pairs Well With</div>
                <div class="pi__pww-product-heading">{{ product.product_information.pairs_well_with.title }}</div>
                <div class="pi__pww-product-subheading text-sm">{{ product.product_information.pairs_well_with_subtitle }}</div>
                <button class="btn btn--primary btn--outline btn--wide btn--sm" @click="atcPWW()">
                  <span>Add to bag</span>
                  <svg class="icon icon--md"><use href="#bag-outline"></use></svg>
                </button>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { ref, reactive, onBeforeMount, onMounted, computed, watch } from 'vue';
  import BuyboxGallery from "./buybox-gallery.vue";
  import BuyboxBundle from './buybox-bundle.vue';
  import BuyboxBundleGeneric from './buybox-bundle-generic.vue';
  import BuyboxOptions from './buybox-options.vue';
  import BuyboxSubscription from './buybox-subscription.vue';
  import BuyboxATC from "./buybox-atc.vue";
  import BuyboxStickyBar from "./buybox-sticky-bar.vue";
  import BuyboxAccor from './buybox-accor.vue';
  import ImageField from "../../global/image.vue";
  import windowResize from '../../../utils/window-resize';

  const props = defineProps({
    product: {
      type: Object,
      default: () => ({})
    },

    isStayBundle: {
      type: Boolean,
      default: false, 
    },

    isOneFlavor: {
      type: Boolean,
      default: false, 
    }
  });

  const product = reactive({ ...props.product });
  const selectedOptionIndex = ref(0);
  const selectedVariant = ref(null);
  const selectedSellingPlan = ref(null);
  const multiPackOptions = ['boxes', 'tubs', 'bottles'];
  const buyboxSubscription = ref(null);
  const { windowWidth } = windowResize()
  const emit = defineEmits(['toggle-bis-modal','toggle-uc-ship-modal']);

  const isMobile = computed(() => {
    return windowWidth.value < 1024;
  })

  onBeforeMount(() => {
    initialSetup();
    //window.refreshYotpoData();
    window.initYotpoData();
  });

  onMounted(() => {
    trackEvent('Viewed Product');
    assignRatingClickEvent();
  });

  const atcPWW= async() => {
    window.openCart();
    emit('toggle-option-drawer');
    await window.Additem({
      id: product.product_information.pairs_well_with.variants[0].id,
      quantity: 1
    })
    emit('track-event', 'Added One-Time to Cart')
  }

  watch(isMobile, (newVal, oldVal) => {
    if (oldVal !== undefined && newVal !== oldVal) {
      window.initYotpoData?.();
    }
  });

  const benefits = computed(() => {
    const metafieldValue = product.product_information.benefits;

    if (Array.isArray(metafieldValue)) {
      return metafieldValue;
    }

    if (typeof metafieldValue === 'string') {
      try {
        const parsed = JSON.parse(metafieldValue);
        return Array.isArray(parsed) ? parsed : [];
      } catch (e) {
        return [];
      }
    }

    return [];
  });

  const shopLocation = computed(() => {
    return window.shopLocation
  });

  const isStayBundle = computed(() => {
    return product.template.includes('bundle') ? true : false;
  })

  const isBundleSingleProduct = computed(() => {
    return product.template === 'bundle' ? true : false;
  })

  const isBundleGeneric = computed(() => {
    return product.template === 'bundle-generic' ? true : false;
  })

  const isOneFlavor = computed(() => {
    return product.template.includes('one-flavor') ? true : false;
  })

  const isMultiPack = computed(() => {
    return product.options.some(option => multiPackOptions.includes(option.name.toLowerCase()));
  });

  const yotpoProductId = computed(() => {
    const { tags } = product;
    const reviewTag = tags.find(tag => tag.startsWith("review-product-id="));
    if(!reviewTag) return product.id;
    
    return reviewTag.split('=')[1];
  });

  const accordianData = computed(() => {
    const resultObject = {};

    Object.entries(product).forEach(([key, value]) => {
      if (key.startsWith('accor_')) {
        if (Array.isArray(value)) {
          // Process array items
          value.forEach(item => {
            const title = item.title?.trim();
            const content = item.content?.trim();

            if (!title || !content) return;

            resultObject[title] ??= { position: item.position, data: [] };
            resultObject[title].data.push(item);
          });
        } else if (value && typeof value === 'object') {
          // Process single object
          resultObject[value.title] = value;
        }
      }
    });

    if(selectedVariant.value.accor_supplement_facts.title || selectedVariant.value.accor_supplement_facts.image) {
      const selectedVariantSupplementFactsAccor = {
        position: "3",
        title: selectedVariant.value.accor_supplement_facts.title,
        image: selectedVariant.value.accor_supplement_facts.image
      };
      resultObject['Supplement Facts'] = selectedVariantSupplementFactsAccor;
    }

    const howAndWhen = selectedVariant.value?.accor_how_and_when;

    if (Array.isArray(howAndWhen) && howAndWhen.length > 0) {
      const hasValidBlock = howAndWhen.some(block => {
        return block.title?.trim() || block.content?.trim();
      });

      if (hasValidBlock) {
        const selectedVariantHowAndWhenAccor = {
          //position: selectedVariant.value.accor_how_and_when[0].position,
          position: "5",
          data: selectedVariant.value.accor_how_and_when
        };
        resultObject[selectedVariant.value.accor_how_and_when[0].title] = selectedVariantHowAndWhenAccor;
        }
    }

    if(selectedVariant.value.accor_ingredients.length) {
      const selectedVariantIngredientAccor = {
        position: "0",
        title: "Ingredients",
        content: selectedVariant.value.accor_ingredients
      };
      resultObject['Ingredients'] = selectedVariantIngredientAccor;
    }

    // Convert resultObject to dataArray and sort by position
    const dataArray = Object.values(resultObject);
    dataArray.sort((a, b) => parseInt(a.position) - parseInt(b.position));

    // Convert sorted array back to object
    const sortedObject = {};
    dataArray.forEach(item => {
      if(item.data) {
        sortedObject[item.data[0].title] = item.data;
      } else {
        sortedObject[item.title] = item;
      }      
    });

    return sortedObject;
  });

  const initialSetup = () => {
    const params = new URLSearchParams(window.location.search);
    const variantParam = params.get('variant');
    selectedVariant.value = variantParam
      ? product.variants.find(variant => variant.id === variantParam)
      : product.variants[0];

    if (selectedVariant.value.has_subscription_plan) {
      // Filter selling plans based on isStayBundle.value
      const filteredPlans = selectedVariant.value.selling_plans.filter(plan => 
        isStayBundle.value 
          ? plan.selling_plan.price_adjustments[0].value === 25 
          : plan.selling_plan.price_adjustments[0].value === 20
      );

      // Select the first matching plan (or handle if no plans match)
      if (filteredPlans.length > 0) {
        selectedSellingPlan.value = {
          id: filteredPlans[0].selling_plan.id,
          name: filteredPlans[0].selling_plan.name,
          discount_type: filteredPlans[0].selling_plan.price_adjustments[0].value_type,
          discount_value: filteredPlans[0].selling_plan.price_adjustments[0].value
        };
      } else {
        // Handle case where no plans match (optional)
        selectedSellingPlan.value = null; // or set a default value
      }
    }

    product.options.forEach((option, index) => {
      option.selected = selectedVariant.value.options[index];
    });

    updateURLParams('update', selectedVariant.value);
    dispatchCustomEvent();
  };

  const updateSelectedVariant = (index) => {
    const { options, variants } = product;
    selectedOptionIndex.value = index;

    const selectedOptions = options.map(option => option.selected.toLowerCase());

    selectedVariant.value = variants.find(variant => {
      return variant.options.every((option, idx) => option.toLowerCase() === selectedOptions[idx]);
    });

    if(!selectedVariant.value && isMultiPack.value && options.length === 3) {
      const availableVariants = variants.filter(variant => {
        return variant.options[0] === options[0].selected && variant.options[1] === options[1].selected
      });

      if (availableVariants.length) {
        selectedVariant.value = availableVariants[0];
        options.forEach((option, index) => {
          option.selected = selectedVariant.value.options[index];
        });
      }
    }

    if(!selectedVariant.value.has_subscription_plan && buyboxSubscription.value) {
      buyboxSubscription.value.isSubscription = false;
    }

    updateURLParams('update', selectedVariant.value);
    dispatchCustomEvent();
  };

  const onUpdateOption = (key,value, index) => {
    let tempSelectedOption = product.options[index].selected;
    product.options[index].selected = value;
    updateSelectedVariant(index);

    setTimeout(() => {
      if(key.toLowerCase() === 'size' && value == '20' && tempSelectedOption != value && buyboxSubscription.value) {
        buyboxSubscription.value.onSubscriptionChange(true)
      }
    })
  };

  const onUpdateSellingPlan = (value, isSubscription) => {
    selectedSellingPlan.value = value;

    if(isSubscription && buyboxSubscription.value) {
      buyboxSubscription.value.isSubscription = true;
    } 
  }

  const onUpdateIsSubscription = (value) => {
    if(buyboxSubscription.value) {
      buyboxSubscription.value.isSubscription = value;
    } 
  }

  const updateURLParams = (type, variant) => {
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);

    if (type === 'update' && variant) {
      params.set('variant', variant.id);
    } else if (type === 'delete') {
      params.delete('color');
    }

    url.search = params.toString();
    window.history.replaceState({ url: url.toString() }, null, url.toString());
  };

  const dispatchCustomEvent = () => {
    const customEvent = new CustomEvent('selectedVariantUpdated', { detail: selectedVariant.value?.ingredient_spotlight });
    window.dispatchEvent(customEvent);
  }

  const trackEvent = (event) => {
    window.trackGTMEvent({
      product: {
        title: product.title,
        id: product.id,
        vendor: product.vendor,
        quantity: 1,
        selected_variant: selectedVariant.value,
        subscription: buyboxSubscription.value?.isSubscription ,
        selling_plan: selectedSellingPlan.value
      },
      event: event
    }) 
  }

  const assignRatingClickEvent = () => {
    document.querySelectorAll('.product__reviews').forEach(item => {
      item.addEventListener('click', (e) => {
        e.preventDefault()
        e.stopPropagation();

        gsap.to(window, {
          duration: 1,
          scrollTo: {
            y: '#reviews',
            offsetY: 0
          }
        });

        return false
      }, {capture: true})
    })
  }

  defineExpose({selectedVariant})
</script>